







































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import FacilityData from '@/ts/FacilityData';
import EmptyImage from '@/components/EmptyImage.vue';
import StringHelper from '@/mixins/StringHelper.vue';

@Component({
    components: {
        EmptyImage,
    },
})
export default class AvailableSharedFacilities extends Mixins(StringHelper) {
    constructor() {
        super();
    }

    get facilities(): FacilityData[] {
        return this.$store.getters['SharedFacilities/getUserSharedFacilities'];
    }

    public showFacilityDetailsOverlay(facility: FacilityData) {
        this.$store.commit(Mutations.SET_USER_SELECTED_FACILITY, facility);
        this.$store.commit(Mutations.SET_FACILITY_DETAILS_OVERLAY_VISIBILITY, true);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_USER_SHARED_FACILITIES);
    }
}
